import React from 'react'
import { graphql } from 'gatsby'

import PageHeader from '../components/PageHeader'
import Layout from '../components/Layout'
import Accordion from '../components/Accordion'
import CategoriesNav from '../components/CategoriesNav'
import { supportNav } from "../commons";

// Export Template for use in CMS preview
export const SupportTemplate = ({ title, accordion = [], body }) => (
  <main>
    <section className="Nav--Container container">
      <CategoriesNav
        hire={true}
        portfolio={false}
        indexName="Support"
        indexSlug="support"
        categories={supportNav}
      />
    </section>

    <PageHeader large title={title} />

    <section className="section">
      <div className="container">
        <Accordion items={accordion} />
      </div>
    </section>
  </main>
)

const Support = ({ data: { page } }) => (
  <Layout
    meta={page.frontmatter.meta || false}
    title={page.frontmatter.title || false}
  >
    <SupportTemplate {...page} {...page.frontmatter} body={page.body} />
  </Layout>
)

export default Support

export const pageQuery = graphql`
  query SupportPage($id: String!) {
    page: mdx(id: { eq: $id }) {
      ...Meta
      body
      frontmatter {
        title
        accordion {
          title
          content {
            title
            description
          }
        }
      }
    }
  }
`
